import { render } from "./selectperson.vue?vue&type=template&id=beaaf310&scoped=true&ts=true"
import script from "./selectperson.vue?vue&type=script&lang=ts"
export * from "./selectperson.vue?vue&type=script&lang=ts"

import "./selectperson.vue?vue&type=style&index=0&id=beaaf310&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beaaf310"]])

export default __exports__